import { Component, Inject, Input, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  formatFilesize,
  formatUnlimited,
  getObjectProperty,
  getResourceDisplayName,
  projectEnv,
} from 'utils';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { CtxButtonComponent } from '../button/button.component';
import { HlmIconComponent } from '../icon';

export type ArrayTableDialogData = {
  title: string;
  columnsToDisplay: string[];
  arrayOfObjects: Record<string, any>[];
};

@Component({
  selector: 'ctx-array-table',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    HlmIconComponent,
    MatTableModule,
    CtxButtonComponent,
  ],
  templateUrl: './array-table.component.html',
})
export class CtxArrayTableComponent {
  /**
   * Since the RESOURCE_NAMES dictionary is only basic and does not handle clashes,
   * license.key is the default in  RESOURCE_NAMES and this tear-off
   * handles the exception of metadata.key.
   * */
  getResourceDisplayName = (name: string) => {
    if (name === 'key') {
      return 'Key';
    } else {
      return getResourceDisplayName(name, projectEnv.get('projectName'));
    }
  };

  /** Ordered array of columns to display */
  @Input() title: string;
  @Input() columnsToDisplay: string[];
  @Input() arrayOfObjects: Record<string, any>[];

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public dialogData: ArrayTableDialogData,
    @Optional()
    public dialogRef: MatDialogRef<CtxArrayTableComponent>
  ) {}

  ngOnInit() {
    // If the table is within a dialog, set the inputs manually from dialog data.
    this.initializeWithDialogData();
  }
  /**
   * Returns formated string for different property type like unlimited for `-1`,etc
   * @param element
   * @param property
   * @returns formated string
   */
  formatCellValue(element: string, property: string): string {
    const value = getObjectProperty(element, property);

    switch (property) {
      case 'size':
        return formatFilesize(value);
      case 'allowedUses':
        return formatUnlimited(value);
      default:
        return value;
    }
  }
  /** Initializes properties with dialogData if required */
  private initializeWithDialogData() {
    if (this.isWithinDialog) {
      this.title = this.dialogData.title;
      this.columnsToDisplay = this.dialogData.columnsToDisplay;
      this.arrayOfObjects = this.dialogData.arrayOfObjects;
    }
  }

  /** True if table is within dialog */
  get isWithinDialog() {
    return (
      this.dialogData &&
      this.dialogRef &&
      this.dialogData.columnsToDisplay &&
      this.dialogData.arrayOfObjects &&
      this.dialogData.title
    );
  }
}
